import { render, staticRenderFns } from "./ConfiguracoesCarrinho.vue?vue&type=template&id=c77e2036&scoped=true&"
import script from "./ConfiguracoesCarrinho.vue?vue&type=script&lang=js&"
export * from "./ConfiguracoesCarrinho.vue?vue&type=script&lang=js&"
import style0 from "./ConfiguracoesCarrinho.vue?vue&type=style&index=0&id=c77e2036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77e2036",
  null
  
)

export default component.exports